import React, { useState, useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import clsx from 'clsx';
import _ from 'lodash';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function MainSelectBoxWithoutBoxComponent(props) {
  const {
    labelName,
    required,
    optionList,
    placeholder,
    defaultValue,
    filterAction,
    disabled,
    select,
    selectedOne = true,
    inputProps,
    InputProps = false,
    className,
    className2,
    isError,
    helperText,
    onBlurAction = false,
  } = props;
  return (
    // <div className={clsx('frr-without-mui-custom-form', className1 || '')}>
    <div className={clsx('form-wrapper db text-left', className || '')}>
      <div className='with-select rmv_border'>
        <TextField
          id={labelName ? _.kebabCase(labelName) : ''}
          label={
            <span className={clsx(isError && '', 'text-nowrap')}>
              {labelName}{' '}
              <span className='mandatory'>{required ? '*' : ''}</span>
            </span>
          }
          fullWidth
          select={select || false}
          disabled={disabled || false}
          placeholder={placeholder}
          inputProps={
            inputProps
              ? {
                  ...inputProps,
                  'aria-hidden': false,
                  id: labelName ? _.kebabCase(labelName) : '',
                }
              : {
                  maxlength: 100,
                  'aria-hidden': false,
                  id: labelName ? _.kebabCase(labelName) : '',
                }
          }
          InputProps={InputProps && InputProps}
          InputLabelProps={{ shrink: true }}
          value={defaultValue}
          onChange={(e) => filterAction(e.target.value)}
          onBlur={(e) => onBlurAction && onBlurAction(e.target.value)}
          className={clsx(className2, isError ? 'mandate-fields' : '')}
          error={!!isError}
          helperText={
            (isError && !_.isNumber(isError) ? isError : '') || helperText || ''
          }
        >
          {select && selectedOne && (
            <MenuItem key='' value='-1' className='frr-dropdown-blank-item' />
          )}
          {select && !_.isEmpty(optionList)
            ? optionList?.map((item, key) => (
                <MenuItem key={key} value={item.id}>
                  {item.name}
                </MenuItem>
              ))
            : null}
        </TextField>
      </div>
    </div>
    // </div>
  );
}

export default function SelectBoxWithoutBoxComponent(props) {
  const {
    defaultValue,
    optionList,
    select,
    disabled,
    className1,
    viewLength = 20,
  } = props;

  const [viewTooltips, setViewTooltips] = useState(false);
  const [tooltipsVal, setTooltipsVal] = useState(defaultValue);

  useEffect(() => {
    let nameView = defaultValue;
    let viewTool = false;
    if (select) {
      const filterList = !_.isEmpty(optionList)
        ? _.filter(optionList, (l) => l.id === defaultValue)
        : [];
      nameView = !_.isEmpty(filterList)
        ? _.filter(filterList, (l) => l.name)
        : defaultValue;
    }
    if (
      disabled &&
      nameView &&
      nameView !== '' &&
      nameView.length > viewLength
    ) {
      viewTool = true;
    }
    setTooltipsVal(nameView);
    setViewTooltips(viewTool);
  }, []);

  return viewTooltips ? (
    <OverlayTrigger
      placement='bottom'
      overlay={<Tooltip id='com-tooltip'>{tooltipsVal}</Tooltip>}
    >
      <div className={clsx('frr-without-mui-custom-form', className1 || '')}>
        <MainSelectBoxWithoutBoxComponent {...props} />
      </div>
    </OverlayTrigger>
  ) : (
    <div className={clsx('frr-without-mui-custom-form', className1 || '')}>
      <MainSelectBoxWithoutBoxComponent {...props} />
    </div>
  );
  // </div>
}

// export default mainSelectBoxWithoutBoxComponent;
